import React from 'react'
import { FormMorphology } from './FormMorphology';
import { Dialog } from 'primereact/dialog';
import { Button } from 'reactstrap';


export const ModalMorphology = (props) => {

    const {
        modal, modalTitle, closeDialog, method,
        validaciones,
        morphology,
        handleInputChange, loading,
        saveCreate, saveUpdate, saveDelete
    } = props;

    return (
        <Dialog
            visible={modal}
            onHide={closeDialog}
            blockScroll
            closable={false}
            modal
            maskClassName="custom-total-mask"
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">
                        <div className="Global-dialog-icon">
                            <i className="icon-image f-20"></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                {modalTitle}
                            </div>
                        </div>
                    </div>
                </div>
            }
            draggable={false}
            className={`Global-dialog Global-dialog Global-blue Global-small-v`}
            footer={
                <>
                    {
                        method === "create" && <Button
                            color="secondary"
                            size="sm"
                            className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                            onClick={saveCreate}
                        >
                            {
                                loading ? "Creando Morfologia" : "Crear Morfologia"
                            }
                        </Button>
                    }
                    {
                        method === "update" && <Button
                            color="secondary"
                            size="sm"
                            className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                            onClick={saveUpdate}
                        >
                            {
                                loading ? "Actualizando Morfologia" : "Actualizar Morfologia"
                            }
                        </Button>
                    }

                    <Button
                        size="sm"
                        color='danger'
                        type="button"
                        onClick={closeDialog}
                    >
                        Cancelar
                    </Button>

                </>
            }
        >

            {
                method === "create"
                    ? <FormMorphology
                        button={"Crear morfologia"}
                        {...{ closeDialog, loading, handleInputChange, validaciones, methodAction: saveCreate }}
                    />
                    : (method === "update")
                        ?
                        <FormMorphology
                            button={"Actualizar morfologia"}
                            {...{ closeDialog, loading, handleInputChange, validaciones, methodAction: saveUpdate, morphology, }} />
                        :
                        null
            }
        </Dialog>
    )
}
